/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";

import Stack from "@mui/material/Stack";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { useDispatch, useSelector } from "react-redux";
import { markModuleRead, fetchUnreadCount } from "app/redux/slice/notificationSlice";
import { useSnackbar } from "notistack";
import Loader from "@jumbo/components/Loader";
import { userType } from "app/helpers/userType";
import { useNavigate } from "react-router-dom";
import {
  addMillPurchaseFromKnitterOrder,
  KNITTER_ORDER_ADD,
  knitterOrderEdit,
} from "app/routes/constant";
import { Icon } from "@iconify/react";
import {
  deleteKnitterOrder,
  getKnitterOrderList,
} from "app/redux/slice/knitterOrderSlice";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import moment from "moment";
import Span from "@jumbo/shared/Span";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";

const KnitterOrder = () => {
  const navigate = useNavigate();

  const {
    isOpen: isGenerateMillPurchase,
    onClose: closeGenerateMillPurchase,
    actionProps: addMillPurchaseActionProps,
    stageAction: changeStatusStageAction,
  } = useDisclosure();

  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();

  const knitterOrderData = useSelector((state) => state?.knitterOrder);
  const supplierData = useSelector((state) => state?.supplier);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [supplierId, setSupplierId] = useState();
  const [orderBy, setOrderBy] = useState("createdAt");
  const [status, setStatus] = useState("All");

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "knitterOrder" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    changeStatusPermission: false,
    deletePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        changeStatusPermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        changeStatusPermission: false,
        deletePermission: false,
      };
      const rolePermission = permissionData?.filter((item) => {
        return item?.moduleName?.includes("Knitter Order") && item;
      });
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "create-knitter-order") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-knitter-order") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "manage-status-knitter-order") {
            permissionValue.changeStatusPermission = true;
          }
          if (num?.name === "update-knitter-order") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    { id: "orderNo", label: "Order No.", sort: true, minWidth: 110 },
    {
      id: "vendor",
      label: "Vendor",
      sort: true,
      render: (row) => row?.supplier?.name,
    },
    {
      id: "product",
      label: "Product",
      sort: true,
      render: (row) => row?.product?.name,
    },
    { id: "quantity", label: "Num Of Role", sort: true, minWidth: 130 },
    { id: "remainingQty", label: "Rem.Role", sort: true },
    { id: "unitPrice", label: "Rate P.Kg", sort: true, minWidth: 110 },
    {
      id: "orderDate",
      label: "Date",
      sort: true,
      minWidth: 120,
      render: (row) => moment(row?.orderDate).format("DD-MM-YYYY"),
    },
    {
      id: "expectedDeliveryDate",
      label: "Exp.Del.Date",
      sort: true,
      render: (row) => moment(row?.expectedDeliveryDate).format("DD-MM-YYYY"),
    },
    { id: "partyChallan", label: "Party Challan", sort: true, minWidth: 105 },
    {
      id: "status",
      label: "Status",
      sort: true,
      render: (row) =>
        row?.status === "Process" ? (
          <Span style={{ color: "red" }}>Process</Span>
        ) : row?.status === "Partial" ? (
          <Span style={{ color: "orange" }}>Partial</Span>
        ) : (
          <Span style={{ color: "green" }}>Complete</Span>
        ),
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 155,
      align: "center",
      render: (row) => (
        <>
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              stageAction(row);
              navigate(knitterOrderEdit(row._id));
            }}
          >
            <EditIcon />
          </IconButton>
          <Tooltip title="Send To Mill">
            <IconButton
              disabled={
                !permission.changeStatusPermission || row?.status === "Complete"
              }
              onClick={() => {
                changeStatusStageAction(row);
              }}
            >
              <Icon icon="vaadin:factory" width="24" height="24" />
            </IconButton>
          </Tooltip>

          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
        </>
      ),
    },
  ];

  const DeleteOrder = () => {
    closeDelete();
    dispatch(deleteKnitterOrder(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("knitter-order-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      ...(supplierId && { supplierId: supplierId?._id }),
      ...(status !== "All" && { status }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getKnitterOrderList(value));
    // Mark notifications as read for this module whenever data is fetched
    dispatch(markModuleRead("Knitter Order")).then(() => {
      dispatch(fetchUnreadCount("Knitter Order"));
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0,0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  const GenerateMillPurchase = () => {
    closeGenerateMillPurchase();
    navigate(addMillPurchaseFromKnitterOrder(addMillPurchaseActionProps?._id));
  };

  useEffect(() => {
    getPermission();
    dispatch(getSupplierList({ sort: 1, field: "name", type: "Knitter" }));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {knitterOrderData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <JumboAutoComplete
                      options={supplierData?.list || []}
                      label="Vendor"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`supplierId`}
                      value={supplierId}
                      onChange={(evt, value) => setSupplierId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="status"
                        id="status"
                        value={status}
                        label="status"
                        size="small"
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <MenuItem></MenuItem>
                        {["All", "Complete", "Process", "Partial"].map(
                          (val) => {
                            return <MenuItem value={val}>{val}</MenuItem>;
                          }
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0,0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Orders List
                </Typography>
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      navigate(KNITTER_ORDER_ADD);
                    }}
                    sx={{
                      mt: { xs: 1, md: 0 },
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Add Order
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={knitterOrderData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={knitterOrderData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </CardContent>
          </Card>
          {permission.createPermission && (
            <DialogConfirm
              isOpen={isGenerateMillPurchase}
              onClose={closeGenerateMillPurchase}
              title="Are you sure you want to generate mill purchase?"
              onConfirm={GenerateMillPurchase}
              btnLabels={{ cancel: "Cancel", confirm: "Send TO Mill" }}
            />
          )}
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the order?"
            onConfirm={DeleteOrder}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default KnitterOrder;
